<template>
  <v-container  ref="barWrapper" fluid fill-height  ma-0 pa-0 >
    <loading-circle
      :show="loader"
    />

    <device-bar
      v-if="getData && getData.cls == 'device'"
      :open="getDeviceBarOpen"
      modalMode
      :modalActive="getData"
      noclose--
      noedit
      @load-devices=""
      @close="() => {this.$emit('close', getData)}"
    />

    <popup-card
      v-if="getData && getData.cls == 'connection'"
      :data="getData"
      @close="() => {this.$emit('close', getData)}"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import DeviceBar from '@/nms/pages/device/device-bar.vue'
import popupCard from '@/nms/pages/topology/popup-card.vue'

// Типы для данных
interface JournalModalData {
  [key: string]: any
}

interface DeviceState {
  open: boolean
}

interface BarState {
  device: DeviceState
}

interface ActiveDevice {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'JOURNAL_MODAL',

  components: {
    loadingCircle,
    DeviceBar,
    popupCard
  },

  props: {
    data: {
      type: Object as () => JournalModalData,
      default: () => ({})
    },
  },

  data(): {
    loader: boolean
    bar: BarState
  } {
    return {
      loader: false,
      bar: {
        device: {
          open: false
        },
      },
    }
  },

  computed: {
    getDeviceBarOpen(): boolean {
      // избавляемся от watcher
      const dev = this.$store.state.devices.activeDevice as ActiveDevice | null
      this.bar.device.open = !!(dev && dev.$id)
      return this.bar.device.open
    },

    getData(): JournalModalData {
      return this.data
    },
  },

  created(): void {
    this.setup()
  },

  methods: {
    async setup(): Promise<void> {
      console.log('JOURNAL_MODAL', 'data', this.data)
      this.reset()
    },

    reset(): void {}
  }
})
</script>

<style scoped>
</style>
